import { BarMeta } from './models';

export const convert = (object: {}[], meta: BarMeta) => {
  if (!object) return { keys: [], series: [] };
  const keys = object.map((item: any) => item[meta.xAxis]);
  return {
    keys,
    series: meta.yAxis.map((serieKey: string, index: number) => ({
      name: meta.legends[index] || '',
      data: object.map((item: any) => item[serieKey]),
    })),
  };
};
